// Add your custom JS here.

// Inject Lucide arrow-up-right icon into all .btn elements
window.addEventListener('load', function () {
	document.querySelectorAll('.btn:not(.btn-icon-added)').forEach(function (btn) {
		btn.classList.add('btn-icon-added');
		var icon = document.createElement('i');
		icon.setAttribute('data-lucide', 'arrow-up-right');
		btn.appendChild(icon);
	});
	if (typeof lucide !== 'undefined') {
		lucide.createIcons();
	}
});

// Mobile menu open/close
document.addEventListener('DOMContentLoaded', function () {
	var openBtn  = document.getElementById('mobile-menu-open');
	var closeBtn = document.getElementById('mobile-menu-close');
	var menu     = document.getElementById('navbarMobileMenu');

	if (!openBtn || !closeBtn || !menu) return;

	function openMenu() {
		menu.classList.add('is-open');
		document.body.style.overflow = 'hidden';
		openBtn.setAttribute('aria-expanded', 'true');
		closeBtn.focus();
	}

	function closeMenu() {
		menu.classList.remove('is-open');
		document.body.style.overflow = '';
		openBtn.setAttribute('aria-expanded', 'false');
		openBtn.focus();
	}

	openBtn.addEventListener('click', openMenu);
	closeBtn.addEventListener('click', closeMenu);

	// Close when tapping a nav link
	menu.querySelectorAll('.nav-link').forEach(function (link) {
		link.addEventListener('click', closeMenu);
	});

	// Close on Escape key
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && menu.classList.contains('is-open')) {
			closeMenu();
		}
	});
});
